import React from 'react';
import { useNetworkQuality } from '../../../utils/useNetworkQuality';

// Passive tracer: logs network quality every interval; no UI modal/output
export default function NetworkTracer() {
  useNetworkQuality({
    intervalMs: 15000,
  });
  return null; // no visual output

}
